"use strict";

var _slicedToArray = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.usePaginationData = exports.usePagination = exports.ellipsis = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = require("react");

var _helpers = require("../../utils/helpers"); // Ellipsis


var ellipsis = '. . .';
exports.ellipsis = ellipsis;

var usePagination = function usePagination(_ref) {
  var dataLength = _ref.dataLength,
      itemsPerPage = _ref.itemsPerPage,
      currentPage = _ref.currentPage,
      _ref$siblings = _ref.siblings,
      siblings = _ref$siblings === void 0 ? 1 : _ref$siblings;
  var paginationRange = (0, _react.useMemo)(function () {
    var totalPageCount = Math.ceil(dataLength / itemsPerPage); // The number of page items is the sum of: siblings, firstPage, lastPage, currentPage, ellipsis(2)

    var totalPageNumbers = siblings + 5; // The maximum number of pages

    var maxPageNumbers = totalPageCount === 5;

    if (totalPageNumbers >= totalPageCount || maxPageNumbers) {
      return (0, _helpers.range)(1, totalPageCount);
    }

    var leftSiblingIndex = Math.max(currentPage - siblings, 1);
    var rightSiblingIndex = Math.min(currentPage + siblings, totalPageCount);
    var firstPageIndex = 1;
    var lastPageIndex = totalPageCount;
    var isLeftEllipsis = leftSiblingIndex > 1;
    var isRightEllipsis = rightSiblingIndex < totalPageCount - 1;

    if (!isLeftEllipsis && isRightEllipsis) {
      var leftItemCount = 2 + 2 * siblings;
      var leftRange = (0, _helpers.range)(1, leftItemCount);
      return [].concat((0, _toConsumableArray2.default)(leftRange), [ellipsis, totalPageCount]);
    }

    if (isLeftEllipsis && !isRightEllipsis) {
      var rightItemCount = 2 + 2 * siblings;
      var rightRange = (0, _helpers.range)(totalPageCount - rightItemCount + 1, totalPageCount);
      return [firstPageIndex, ellipsis].concat((0, _toConsumableArray2.default)(rightRange));
    }

    if (isLeftEllipsis && isRightEllipsis) {
      var middleRange = (0, _helpers.range)(leftSiblingIndex, rightSiblingIndex);
      return [firstPageIndex, ellipsis].concat((0, _toConsumableArray2.default)(middleRange), [ellipsis, lastPageIndex]);
    }

    return null;
  }, [dataLength, itemsPerPage, siblings, currentPage]);
  return paginationRange;
};

exports.usePagination = usePagination;

var usePaginationData = function usePaginationData(data, itemsPerPage) {
  var _ref2 = (0, _react.useState)(1),
      _ref3 = _slicedToArray(_ref2, 2),
      currentPage = _ref3[0],
      setCurrentPage = _ref3[1];

  var currentPageData = (0, _react.useMemo)(function () {
    var firstPageIndex = (currentPage - 1) * itemsPerPage;
    var lastPageIndex = firstPageIndex + itemsPerPage;
    return data && Array.isArray(data) ? data.slice(firstPageIndex, lastPageIndex) : [];
  }, [currentPage, data, itemsPerPage]);
  return {
    currentPage: currentPage,
    setCurrentPage: setCurrentPage,
    currentPageData: currentPageData
  };
};

exports.usePaginationData = usePaginationData;